module.exports = __webpack_public_path__ + "static/media/picsart.467f568a.svg";